import Navigation from './navigation/Navigation';
import 'bootstrap/dist/css/bootstrap.min.css';
function App() {
  return (
    <Navigation />
  );
}

export default App;
